 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		17: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"8fb5dbc09e506c70258e16b6e48c6a5b1195e539","2":"5ba45f63acdc5aca112f26883a7e051cb76ebc81","3":"1bc699b90fe94e7c2de1031992cde3a4b2a67425","4":"953529affb241643b097b7a172547e8e588c10b7","5":"framework","6":"33ce6ab0","7":"4c355f13","8":"c05b8182","9":"component---src-pages-layout-js","10":"068de6f06151eeb4d545e13865e6b6ef0514e03e","11":"fa1a4ddbc755172e76f8af1687f1491052abe762","12":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","13":"b9b041f39dc3568dd313b944196020ea562c7d57","14":"bc62dab504a71ef8c5d240a105694d09627f06f3","15":"component---src-pages-integration-builder-sections-code-tsx","16":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","18":"11e8d57d","20":"4b80be75","21":"5cf42e9e","22":"962beaf7","24":"component---src-pages-404-js","25":"component---src-pages-banner-js","26":"component---src-pages-build-better-js","27":"component---src-pages-classic-home-js","28":"component---src-pages-docs-template-js","29":"component---src-pages-integration-builder-index-tsx","30":"component---src-pages-integration-builder-sections-build-tsx","31":"component---src-pages-integration-builder-sections-card-generator-tsx","32":"component---src-pages-integration-builder-sections-configure-tsx","33":"component---src-pages-integration-builder-sections-demo-tsx","34":"component---src-pages-integration-builder-sections-help-modal-tsx","35":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","36":"component---src-pages-integration-builder-sections-preview-tsx","37":"component---src-pages-integration-builder-sections-take-live-tsx","38":"component---src-pages-internal-js","39":"component---src-pages-signup-js","40":"component---src-pages-signupauto-js","41":"component---src-pages-support-js","42":"component---src-pages-thankyou-js","43":"component---src-pages-unsubscribe-js","44":"component---src-pages-video-collection-tsx","45":"component---src-pages-video-home-tsx","46":"component---src-pages-video-watch-tsx","47":"component---src-templates-template-layout-js","48":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"03e26d6c68adf28137b1","2":"7ffbc94115aa4dfa04fa","3":"1a64da34a55b9a082d6f","4":"18bc45209ebd4ba07106","5":"0747ebf1c29a652cf4df","6":"b2b72e861f2449c1fffa","7":"85730f477372987316c3","8":"01bb6b3c0816b90d6e27","9":"a5266df81263a35a3a7f","10":"2d2d6218c224a23fed7e","11":"3b556eb8ce94785de06e","12":"0a67c823eacb4b56edf3","13":"6d2814078eb2e47a7e62","14":"c2b476a02146d32965dd","15":"186ea92c7a4a5b19e230","16":"1674e1559173fc23c2e1","18":"df9c3999fd9e0e0e9efa","20":"d7a442d1ccb9fededc12","21":"748a792b5e49ed841f31","22":"b76e8ae8412f047ad94c","24":"4c5985f7c818b2e186c9","25":"bb8e2375bcc567bf1e2e","26":"ee65d347e6517f83f299","27":"f54cf9ca4d551810d99d","28":"39c4ffca194197d031e3","29":"1fb4d0038607c69767de","30":"5dc11fd91f6182ba5fee","31":"89961d10e076569ca91f","32":"93d1a9bbdb9146d203da","33":"3e029250f7757e4fe437","34":"6908cd2afd3fb4d1a74c","35":"12356b2a87f12f9e9b71","36":"ce299a1dcb981cc9bc5e","37":"6f40e5048ed3c0f6446c","38":"24d09ce12bf0b17720d7","39":"36cf144c2a2fe98b956b","40":"b0177fcb7007259b2213","41":"5b4dc3b3a7fbf543df94","42":"f66cdab8713eb15dc03b","43":"692ce689515fa2c5e08b","44":"17f000a8ca7510700318","45":"f646b03cb9a00cf8094d","46":"1cec315b2bf67407b1bb","47":"5ab161e6870d3891be27","48":"2c754599468426af3b9d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"8fb5dbc09e506c70258e16b6e48c6a5b1195e539","2":"5ba45f63acdc5aca112f26883a7e051cb76ebc81","3":"1bc699b90fe94e7c2de1031992cde3a4b2a67425","4":"953529affb241643b097b7a172547e8e588c10b7","5":"framework","6":"33ce6ab0","7":"4c355f13","8":"c05b8182","9":"component---src-pages-layout-js","10":"068de6f06151eeb4d545e13865e6b6ef0514e03e","11":"fa1a4ddbc755172e76f8af1687f1491052abe762","12":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","13":"b9b041f39dc3568dd313b944196020ea562c7d57","14":"bc62dab504a71ef8c5d240a105694d09627f06f3","15":"component---src-pages-integration-builder-sections-code-tsx","16":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","18":"11e8d57d","20":"4b80be75","21":"5cf42e9e","22":"962beaf7","24":"component---src-pages-404-js","25":"component---src-pages-banner-js","26":"component---src-pages-build-better-js","27":"component---src-pages-classic-home-js","28":"component---src-pages-docs-template-js","29":"component---src-pages-integration-builder-index-tsx","30":"component---src-pages-integration-builder-sections-build-tsx","31":"component---src-pages-integration-builder-sections-card-generator-tsx","32":"component---src-pages-integration-builder-sections-configure-tsx","33":"component---src-pages-integration-builder-sections-demo-tsx","34":"component---src-pages-integration-builder-sections-help-modal-tsx","35":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","36":"component---src-pages-integration-builder-sections-preview-tsx","37":"component---src-pages-integration-builder-sections-take-live-tsx","38":"component---src-pages-internal-js","39":"component---src-pages-signup-js","40":"component---src-pages-signupauto-js","41":"component---src-pages-support-js","42":"component---src-pages-thankyou-js","43":"component---src-pages-unsubscribe-js","44":"component---src-pages-video-collection-tsx","45":"component---src-pages-video-home-tsx","46":"component---src-pages-video-watch-tsx","47":"component---src-templates-template-layout-js","48":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"d8241d1612be55b93052","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/migrationv1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
